import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@fontsource/opendyslexic";
import { auth } from "./firebase/index";
import { mapGetters } from "vuex";
import i18n from "./i18n";
Vue.config.productionTip = false;
// import HeartbeatClient from 'ars-hbclient';

let app;

auth.onAuthStateChanged((kiosk) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,

      render: function (h) {
        return h(App, { props: {} });
      },

      data() {
        return {
          avatar: undefined,
        };
      },

      computed: {
        ...mapGetters([
          "getAvatarLoaded",
          "getKioskProfile",
          "getEnableAvatar",
        ]),
      },

      watch: {
        $route(to, from) {
          if (to.path !== "/login" && from.path !== "/login") {
            this.$nextTick(() => {
              if (this.getEnableAvatar) {
                const newAvatarComp = this.findAvatarComponent(this);
                const newWidth = newAvatarComp.width - 1;
                if (newAvatarComp) {
                  this.$nextTick(() => {
                    newAvatarComp.$el.replaceChild(
                      this.avatar.$el.children[0],
                      newAvatarComp.$el.children[0]
                    );
                    this.avatar = newAvatarComp;
                    this.avatar.width = newWidth;
                  });
                }
              }
            });
          }
        },
        getAvatarLoaded(newVal) {
          if (newVal) {
            this.avatar = this.findAvatarComponent(this);
          }
        },
      },

      methods: {
        findAvatarComponent: function (parent) {
          let found = parent.$children.find((child) => {
            return child.$options.name === "avatar";
          });
          for (let i = 0; !found && i < parent.$children.length; i++) {
            found = this.findAvatarComponent(parent.$children[i]);
          }
          return found;
        },
      },

      mounted() {
        //this.avatar = this.findAvatarComponent(this);

        // document.addEventListener("visibilitychange", this.onVisibilityChange);


      },

      i18n,

      beforeMount() {
        store.commit("setAppDimensions");
        // window["console"]["log"] = function () { };
        // console.warn = function () { };
        // console.error = function () { };
      },
    }).$mount("#app");
  }
  if (kiosk) {
    store.dispatch("fetchKioskProfile", kiosk);

    // const hbClient = new HeartbeatClient();
    // console.log(this.getKioskProfile,"This is the getKioskProfile val.");
    // hbClient.connect({
    //   id: 'Chester Test Kiosk ',
    //   severity: "high",
    //   singleton: true, // Set this to false if you're handling multiple instances
    //   frequency: 2000,
    //   fallback: 8000,
    //   instance_id: -1,
    //   secret:
    //     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhcnMiLCJpYXQiOjE3MjQ0NDY2OTJ9.-d0BoZYHLPiVf66kHr_ZfiO_O8UwoVTb0sP1EXib3Jc",
    // });
    console.log("Stuck Here");
    store.dispatch("manageKioskPresence", kiosk);
    setInterval(() => {
      store.dispatch("manageKioskPresence", kiosk);
    }, 3600000);
    // setInterval(() => { store.dispatch('manageKioskPresence', kiosk); }, 2000)
  }
});
